import PropTypes from 'prop-types';

import { Box } from '@mui/material';
import LogoApp from './LogoApp';

import useAuth from '../../hooks/useAuth';
import { useSelector } from '../../redux/store';

const LogoCompany = ({ sx }) => {
  const { logo: logoUser } = useSelector((state) => state.files); // Specific logo (ex : resource > contract > attached company)
  const {
    env: { logo: logoMainCompany }, // Logo of the main company
    hasClientRole,
    isResource
  } = useAuth();

  const logo = isResource || hasClientRole ? logoUser : logoMainCompany;

  if (logo) {
    return <Box id="logo" alt="Logo de la société" sx={styleLogoCompany(sx, logo)} />;
  }

  return <LogoApp sx={{ styleLogo, ...sx }} />;
};

const styleLogoCompany = (sx, logo) => ({
  background: `center / contain no-repeat url("${logo}")`,
  ...styleLogo,
  ...sx
});

const styleLogo = {
  minHeight: 96,
  height: '100%',
  width: '100%'
};

LogoCompany.propTypes = {
  sx: PropTypes.object
};

export default LogoCompany;
